import { render } from "./stack5DimFollowStatus.vue?vue&type=template&id=7aa543d8&scoped=true"
import script from "./stack5DimFollowStatus.vue?vue&type=script&lang=js"
export * from "./stack5DimFollowStatus.vue?vue&type=script&lang=js"

import "./stack5DimFollowStatus.vue?vue&type=style&index=0&id=7aa543d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa543d8"]])

export default __exports__